module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/5_38fbf42c212b55f6219b464bcac6f61a.png";